
import { toString } from "../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { replace, interpolate, toText, join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { comparePrimitives, equals, int32ToString, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ColoredDot } from "../Components/ColoredDot.js";
import { tryFind, choose, sortBy, isEmpty, filter, empty, map, toArray, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { useTranslation } from "react-i18next";
import { Table } from "../Widgets/Table/Table.js";
import { CategoryUtilizationDto, UtilizationLevel__ToI18nString } from "../Shared/Utilization.js";
import { ColumnDefinition$1, CellContent } from "../Widgets/Table/Types.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Msg } from "./Types.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { MultiSelect } from "../Components/Select.js";
import { unwrap, map as map_1, defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { map as map_2 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { Hierarchy_getDisplayName } from "../Shared/Category.js";
import { DatePicker } from "../Components/DatePicker.js";
import { Button } from "../Components/Button.js";
import { Skeleton } from "../Components/Skeleton.js";

function formatDate(date) {
    return toString(date, "dd.MM.yyyy");
}

function formatPeriod(period) {
    return concat(formatDate(period.StartDate), " – ", ...formatDate(period.EndDate));
}

function levelColor(level) {
    switch (level) {
        case "medium":
            return "green";
        case "high":
            return "orange";
        default:
            return "red";
    }
}

function levelBarColor(level) {
    switch (level) {
        case "medium":
            return "bg-[#50BF00]";
        case "high":
            return "bg-[#EBA44D]";
        default:
            return "bg-[#F99D9D]";
    }
}

function SummaryTile(props) {
    let elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", toList(delay(() => append(singleton("flex"), delay(() => append(singleton("items-center"), delay(() => append(singleton("gap-2"), delay(() => append(singleton("rounded-lg"), delay(() => append(singleton("border"), delay(() => append(singleton("bg-white"), delay(() => append(singleton("px-4"), delay(() => append(singleton("py-3"), delay(() => append(singleton("cursor-pointer"), delay(() => append(singleton("select-none"), delay(() => (props.IsActive ? append(singleton("border-primary"), delay(() => append(singleton("ring-1"), delay(() => singleton("ring-primary"))))) : append(singleton("border-border"), delay(() => singleton("hover:border-primary")))))))))))))))))))))))))))], ["onClick", (_arg) => {
        props.OnClick();
    }], (elems = [createElement(ColoredDot, {
        Color: props.Color,
    }), reactElement("span", {
        className: join(" ", ["text-2xl", "font-semibold"]),
        children: int32ToString(props.Count),
    }), reactElement("span", {
        className: join(" ", ["text-sm"]),
        children: props.Label,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function UtilizationBar(props) {
    let elems_1, elems;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "min-w-32"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-2", "flex-1", "rounded-full", "bg-[#EFEFEF]", "overflow-hidden"])], (elems = [reactElement("div", {
        className: join(" ", ["h-full", "rounded-full", levelBarColor(props.Level)]),
        style: {
            width: props.Percent + "%",
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("span", {
        className: join(" ", ["text-sm", "tabular-nums", "w-10", "text-right"]),
        children: toText(interpolate("%d%P() %%", [props.Percent])),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function UtilizationTable(props) {
    let TableRows;
    const t = useTranslation()[0];
    return createElement(Table, (TableRows = toArray(props.Utilization.Tools), {
        ColumnDefinitions: [new ColumnDefinition$1("level", "", t("utilization.level"), (row) => (new CellContent(0, [t(UtilizationLevel__ToI18nString(row.Level))])), "select", "text"), new ColumnDefinition$1("displayName", "", t("general.tool"), (row_1) => (new CellContent(3, [row_1.DisplayName, () => {
            RouterModule_nav(ofArray(["tools", row_1.ToolId]), 1, 1);
        }])), "text", "button"), new ColumnDefinition$1("inventoryNumber", "", t("tool.inventory_number"), (row_2) => (new CellContent(0, [row_2.InventoryNumber])), "text", "text"), new ColumnDefinition$1("storage", "", t("general.storage"), (row_3) => (new CellContent(0, [row_3.StorageName])), "select", "text"), new ColumnDefinition$1("utilizationPercent", "", t("utilization.percent"), (row_4) => (new CellContent(2, [createElement(UtilizationBar, {
            Level: row_4.Level,
            Percent: row_4.UtilizationPercent,
        })])), "none", "text"), new ColumnDefinition$1("usedDays", "", t("utilization.used_days"), (row_5) => (new CellContent(0, [replace(replace(t("utilization.days_of_days"), "{{used}}", int32ToString(row_5.UsedDays)), "{{total}}", int32ToString(row_5.TotalDays))])), "text", "text"), new ColumnDefinition$1("usedPeriods", "", t("utilization.used_periods"), (row_6) => (new CellContent(0, [join(", ", map(formatPeriod, row_6.UsedPeriods))])), "text", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["displayName", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "category-utilization-table",
        TableRows: TableRows,
    }));
}

function UtilizationResult(props) {
    let elems_2;
    const t = useTranslation()[0];
    let filteredUtilization;
    const matchValue = props.LevelFilter;
    if (matchValue == null) {
        filteredUtilization = props.Utilization;
    }
    else {
        const level = matchValue;
        const bind$0040 = props.Utilization;
        filteredUtilization = (new CategoryUtilizationDto(bind$0040.Categories, bind$0040.StartDate, bind$0040.EndDate, filter((tool) => (tool.Level === level), props.Utilization.Tools), bind$0040.LowCount, bind$0040.MediumCount, bind$0040.HighCount, bind$0040.AverageUtilizationPercent));
    }
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = toList(delay(() => {
        let elems_1, Label, Label_1, Label_2, elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-3"])], (elems_1 = [createElement(SummaryTile, (Label = t("utilization.level_low"), {
            Color: levelColor("low"),
            Count: props.Utilization.LowCount,
            IsActive: equals(props.LevelFilter, "low"),
            Label: Label,
            OnClick: () => {
                props.Dispatch(new Msg(6, ["low"]));
            },
        })), createElement(SummaryTile, (Label_1 = t("utilization.level_medium"), {
            Color: levelColor("medium"),
            Count: props.Utilization.MediumCount,
            IsActive: equals(props.LevelFilter, "medium"),
            Label: Label_1,
            OnClick: () => {
                props.Dispatch(new Msg(6, ["medium"]));
            },
        })), createElement(SummaryTile, (Label_2 = t("utilization.level_high"), {
            Color: levelColor("high"),
            Count: props.Utilization.HighCount,
            IsActive: equals(props.LevelFilter, "high"),
            Label: Label_2,
            OnClick: () => {
                props.Dispatch(new Msg(6, ["high"]));
            },
        })), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "gap-2", "rounded-lg", "border", "border-border", "bg-white", "px-4", "py-3"])], (elems = [reactElement("span", {
            className: join(" ", ["text-2xl", "font-semibold"]),
            children: toText(interpolate("%d%P() %%", [props.Utilization.AverageUtilizationPercent])),
        }), reactElement("span", {
            className: join(" ", ["text-sm"]),
            children: t("utilization.average"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(singleton(reactElement("div", {
            className: join(" ", ["text-xs", "text-text-muted"]),
            children: t("utilization.calculation_hint"),
        })), delay(() => (isEmpty(filteredUtilization.Tools) ? singleton(reactElement("div", {
            className: join(" ", ["text-sm", "text-text-muted"]),
            children: t("utilization.no_tools_for_level"),
        })) : singleton(createElement(UtilizationTable, {
            Utilization: filteredUtilization,
        })))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function UtilizationView() {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, []);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_1 = toList(delay(() => {
        let elems, Label_3, matchValue_1;
        const matchValue = state_1.Categories;
        if (matchValue.tag === 1) {
            const categories = matchValue.fields[0];
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-1", "md:grid-cols-4", "gap-4", "items-end"])], (elems = [createElement(MultiSelect, {
                ComponentState: componentState,
                IsClearable: true,
                Label: t("utilization.categories"),
                NoOptionsMessage: "utilization.no_categories",
                OnChange: (options) => {
                    dispatch(new Msg(1, [defaultArg(map_1((options_1) => ofArray(map_2((_arg_3) => _arg_3.value, options_1)), options), empty())]));
                },
                Options: sortBy((_arg_2) => _arg_2.label, map((category) => ({
                    label: Hierarchy_getDisplayName(categories, category),
                    value: category.Id,
                }), categories), {
                    Compare: (x, y) => (comparePrimitives(x, y) | 0),
                }),
                PlaceholderKey: "utilization.select_categories",
                TestId: "utilization-category-select-test-id",
                Value: map((category_2) => ({
                    label: Hierarchy_getDisplayName(categories, category_2),
                    value: category_2.Id,
                }), choose((categoryId) => tryFind((category_1) => equals(category_1.Id, categoryId), categories), state_1.SelectedCategoryIds)),
            }), createElement(DatePicker, {
                ComponentState: componentState,
                IsClearable: true,
                Label: t("utilization.start_date"),
                MaxDate: unwrap(state_1.EndDate),
                OnChange: (arg) => {
                    dispatch(new Msg(2, [arg]));
                },
                TestId: "utilization-start-date-test-id",
                Value: unwrap(state_1.StartDate),
            }), createElement(DatePicker, {
                ComponentState: componentState,
                IsClearable: true,
                Label: t("utilization.end_date"),
                MinDate: unwrap(state_1.StartDate),
                OnChange: (arg_1) => {
                    dispatch(new Msg(3, [arg_1]));
                },
                TestId: "utilization-end-date-test-id",
                Value: unwrap(state_1.EndDate),
            }), createElement(Button, (Label_3 = t("utilization.check"), {
                ComponentState: (matchValue_1 = state_1.SelectedCategoryIds, (state_1.StartDate != null) ? ((state_1.EndDate != null) ? ((!isEmpty(matchValue_1) && !state_1.FormState.IsLoading) ? "enabled" : "disabled") : "disabled") : "disabled"),
                Label: Label_3,
                OnClick: () => {
                    dispatch(new Msg(4, []));
                },
                TestId: "utilization-check-test-id",
                Variant: "primary",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                if (state_1.FormState.IsLoading) {
                    return singleton(createElement(Skeleton, {
                        Variant: "table",
                    }));
                }
                else {
                    const matchValue_5 = state_1.Utilization;
                    if (matchValue_5 == null) {
                        return singleton(reactElement("div", {
                            className: join(" ", ["text-sm", "text-text-muted"]),
                            children: t("utilization.select_hint"),
                        }));
                    }
                    else {
                        const utilization = matchValue_5;
                        return append(singleton(reactElement("div", {
                            className: join(" ", ["text-sm", "text-text-muted"]),
                            children: replace(replace(replace(t("utilization.result_title"), "{{category}}", join(", ", map((_arg_5) => _arg_5.CategoryName, utilization.Categories))), "{{startDate}}", formatDate(utilization.StartDate)), "{{endDate}}", formatDate(utilization.EndDate)),
                        })), delay(() => (isEmpty(utilization.Tools) ? singleton(reactElement("div", {
                            className: join(" ", ["text-sm"]),
                            children: t("utilization.no_tools_in_selection"),
                        })) : singleton(createElement(UtilizationResult, {
                            Dispatch: dispatch,
                            LevelFilter: unwrap(state_1.LevelFilter),
                            Utilization: utilization,
                        })))));
                    }
                }
            }));
        }
        else {
            return singleton(createElement(Skeleton, {
                Variant: "table",
            }));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

